import { render, staticRenderFns } from "./integration-list.vue?vue&type=template&id=857957ae&scoped=true&"
import script from "./integration-list.vue?vue&type=script&lang=js&"
export * from "./integration-list.vue?vue&type=script&lang=js&"
import style0 from "./integration-list.vue?vue&type=style&index=0&id=857957ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857957ae",
  null
  
)

export default component.exports